export enum UserMenuKeys {
  Profile = 'profile',
}
